class HeaderMenu {
    constructor(root) {
      this.root = root;
      this.button = root.querySelector('.header__menu');
      this.menu = root.querySelector('.header__menu-wrap');
      this.buttonClose = root.querySelector('.header__menu-close');
  
      if (!this.button || !this.menu) return;
  
      // bind
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.toggle = this.toggle.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
  
      // events
      this.button.addEventListener('click', this.toggle);
  
      if (this.buttonClose) {
        this.buttonClose.addEventListener('click', this.close);
      }
  
      document.addEventListener('keydown', this.handleKeydown);
    }
  
    open() {
      this.button.setAttribute('aria-expanded', 'true');
      this.menu.removeAttribute('hidden');
      this.menu.removeAttribute('inert');
  
      // 最初のフォーカス可能要素へ（任意だけど実務ではほぼ必須）
      const firstFocusable = this.menu.querySelector(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      firstFocusable?.focus();
    }
  
    close() {
      this.button.setAttribute('aria-expanded', 'false');
      this.menu.setAttribute('hidden', '');
      this.menu.setAttribute('inert', '');
  
      // フォーカスをトリガーに戻す
      this.button.focus();
    }
  
    toggle() {
      const expanded = this.button.getAttribute('aria-expanded') === 'true';
      expanded ? this.close() : this.open();
    }
  
    handleKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    }
  
    destroy() {
      this.button.removeEventListener('click', this.toggle);
  
      if (this.buttonClose) {
        this.buttonClose.removeEventListener('click', this.close);
      }
  
      document.removeEventListener('keydown', this.handleKeydown);
    }
  }
  
  /* 初期化 */
  const initHeaderMenu = () => {
    const groups = document.querySelectorAll(
      '.shopify-section-group-header-group'
    );
  
    groups.forEach((group) => {
      // 多重初期化防止
      if (group.__headerMenuInstance) return;
  
      const header = group.querySelector('.header');
      if (!header) return;
  
      group.__headerMenuInstance = new HeaderMenu(header);
    });
  };
  
  /* 後始末（テーマエディタ用） */
  const destroyHeaderMenu = (event) => {
    const group = event.target;
  
    if (group.__headerMenuInstance) {
      group.__headerMenuInstance.destroy();
      delete group.__headerMenuInstance;
    }
  };
  
  /* Shopify & ローカル両対応 */
  document.addEventListener('DOMContentLoaded', initHeaderMenu);
  document.addEventListener('shopify:section:load', initHeaderMenu);
  document.addEventListener('shopify:section:unload', destroyHeaderMenu);
  